import {createSelector} from 'reselect';

const selectMedia = (state) => state.media;

const selectSignedMediaList = createSelector(selectMedia, (state) => state.signedMediaList);

const makeSelectSignedMediaListItem = (mediaIdList) =>
    createSelector(selectSignedMediaList, (signedMediaList) => {
        const signedDataSet = signedMediaList.filter((signedItem) =>
            mediaIdList.find((mediaItem) => signedItem.mediaId === mediaItem)
        );

        return signedDataSet.length > 0 ? signedDataSet : undefined;
    });

export {makeSelectSignedMediaListItem, selectSignedMediaList};
